import { createFileRoute } from "@tanstack/react-router";
import { VehiclesPage } from "@/vehicles/VehiclesPage";

export const Route = createFileRoute("/_authenticated/vehicles")({
  validateSearch: (search: Record<string, unknown>): { page: number } => {
    const page = Number(search.page);
    return { page: Number.isSafeInteger(page) && page >= 1 ? page : 1 };
  },
  component: VehiclesPage,
});
